import { AsyncAction, AsyncThunkActionVoid } from 'actions/actions.types'
import {
  fetchAlbumsAttachSwitchApi,
  photosAlbumAttachDeleteApi,
} from 'api/photo/photosAlbumAttachApi'
import { hasUserRestrictions } from 'functions/hasUserRestrictions'

export const fetchAlbumAttachAction =
  (): AsyncThunkActionVoid => (dispatch, getState) => {
    const state = getState()

    if (
      !state.photosAlbumAttach?.attachAlbumLoading &&
      !state.photosAlbumAttach.attachAlbumId
    ) {
      dispatch(fetchAlbumAttachPlainAction(hasUserRestrictions(state)))
    }

    return Promise.resolve()
  }

export const FETCH_ALBUM_ATTACH_PHOTOS = 'FETCH_ALBUM_ATTACH_PHOTOS' as const

interface FetchAlbumAttachPlainAction extends AsyncAction<any> {
  type: typeof FETCH_ALBUM_ATTACH_PHOTOS
}

export const fetchAlbumAttachPlainAction = (userHasRestrictions: boolean) => ({
  type: FETCH_ALBUM_ATTACH_PHOTOS,
  promise: () =>
    fetchAlbumsAttachSwitchApi({
      userHasRestrictions,
    }),
})

export const PHOTOS_ATTACH_DELETE = 'PHOTOS_ATTACH_DELETE' as const

interface PhotosAttachDeleteAction extends AsyncAction {
  type: typeof PHOTOS_ATTACH_DELETE
  removedPhotos: number[]
}

export const photosAttachDeleteAction = (photos: number[]) => ({
  type: PHOTOS_ATTACH_DELETE,
  removedPhotos: photos,
  promise: () => photosAlbumAttachDeleteApi(photos),
})

export type PhotosAttachType =
  | FetchAlbumAttachPlainAction
  | PhotosAttachDeleteAction
